export enum SetPointVarianceTimeframeEnum {
    Hours = 2,
    Days = 3,
    Months = 5
}
